import { SpendingTrendsElement, SpendingTrendsFilter } from '@core/domain/model/consumption/spending-trends.model';
import { DateUtil } from '@core/services/date/date.util';

export type SpendingTrendsState = {
  tab: 'spending' | 'consumption';
  spending: {
    filter: SpendingTrendsFilter;
    current: SpendingTrendsElement[];
    previous: SpendingTrendsElement[];
  };
  consumption: {
    filter: SpendingTrendsFilter;
    current: SpendingTrendsElement[];
    previous: SpendingTrendsElement[];
  };
};

const previousMonths = DateUtil.previousNaturalMonths();

export const spendingTrendsInitialState: SpendingTrendsState = {
  tab: 'consumption',
  spending: {
    filter: {
      societies: [],
      installations: [],
      ...previousMonths,
    },
    previous: [],
    current: [],
  },
  consumption: {
    filter: {
      societies: [],
      installations: [],
      ...previousMonths,
    },
    previous: [],
    current: [],
  },
};
